import Vue from 'vue'
import Vuex from 'vuex'
import createPlugin from 'logrocket-vuex'

import mApp from './modules/app'
import mGps from './modules/gps'
import mTabs from './modules/tabs'
import mMixins from './modules/mixins'
import mAlerts from './modules/alerts'

import mOrc from '../modules/orcamento/Store'

Vue.use(Vuex)

import LogRocket from 'logrocket';
if(process.env.NODE_ENV == 'production'){
    LogRocket.init('eqvd1e/hefesto');
}
const logrocketPlugin = createPlugin(LogRocket);

if(document.head.querySelector('meta[name="logged-user-id"]')){
    LogRocket.identify(parseInt(document.head.querySelector('meta[name="logged-user-id"]').content), {
        name: document.head.querySelector('meta[name="logged-user"]').content,
        email: document.head.querySelector('meta[name="logged-user-email"]').content,
        company: parseInt(document.head.querySelector('meta[name="user-company"]').content)
    });
}

const store = new Vuex.Store({
    plugins: [
        logrocketPlugin
    ],
    state: {
        newLog: true,
        language: '',
        warehouse: 0,
        dossierLocation: 0,
        auth: window.esApp.State.isAuthenticated,
        name: window.esApp.Config.appName,
        getUrl: document.head.querySelector('meta[name="get-url"]').content,
        version: document.head.querySelector('meta[name="app-version"]').content,
        csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        maxFileSize: document.head.querySelector('meta[name="max-file-size"]').content,
        loggedUser: document.head.querySelector('meta[name="logged-user"]') ? document.head.querySelector('meta[name="logged-user"]').content : null,
        loggedUserId: document.head.querySelector('meta[name="logged-user-id"]') ? document.head.querySelector('meta[name="logged-user-id"]').content : null,
        company: document.head.querySelector('meta[name="user-company"]') ? parseInt(document.head.querySelector('meta[name="user-company"]').content) : null,
        loggedUserEmail: document.head.querySelector('meta[name="logged-user-email"]') ? document.head.querySelector('meta[name="logged-user-email"]').content : null,
        showHumanResourcesInErp: document.head.querySelector('meta[name="show-human-resources-in-erp"]') ? document.head.querySelector('meta[name="show-human-resources-in-erp"]').content : true,
        showAliAloInProcess: document.head.querySelector('meta[name="show-ali-alo-in-process"]') ? document.head.querySelector('meta[name="show-ali-alo-in-process"]').content : true,
        showLodComInProcess: document.head.querySelector('meta[name="show-lod-com-in-process"]') ? document.head.querySelector('meta[name="show-lod-com-in-process"]').content : false,
        copyright: {
            name: document.head.querySelector('meta[name="copyright-company-name"]').content,
            link: document.head.querySelector('meta[name="copyright-company-link"]').content,
            showPoweredBy: (document.head.querySelector('meta[name="show-powered-by"]') ? document.head.querySelector('meta[name="show-powered-by"]').content : false),
            showLogo: (document.head.querySelector('meta[name="show-logo"]') ? document.head.querySelector('meta[name="show-logo"]').content : false),
            showAppName: (document.head.querySelector('meta[name="show-app-name"]') ? document.head.querySelector('meta[name="show-app-name"]').content : true),
            showAppBy: (document.head.querySelector('meta[name="show-app-by"]') ? document.head.querySelector('meta[name="show-app-by"]').content : true)
        }
    },
    mutations: {
        company: (state, id) => {
            state.company = id;
        },
        language: (state, i18n) => {
            state.language = i18n;
        },
        newLog: (state) => {
            state.newLog = false;
        },
        warehouse: (state, id) => {
            state.warehouse = id;
        },
        dossierLocation : (state, id) => {
            state.dossierLocation = id;
        },
        showHumanResourcesInErp: (state, val) => {
            state.showHumanResourcesInErp = val;
        },
        showAliAloInProcess: (state, val) => {
            state.showAliAloInProcess = val;
        },
        showLodComInProcess: (state, val) => {
            state.showLodComInProcess = val;
        },
    },
    getters: {
        company: (state) => {
            return state.company;
        },
        csrfToken: (state) => {
            return state.csrfToken;
        },
        isAuthenticated: (state) => {
            return state.auth;
        },
        AppName: (state) => {
            return state.name;
        },
        language: (state) => {
            return state.language;
        },
        maxFileSize: (state) => {
            return state.maxFileSize;
        },
        getUrl: (state) => {
            return state.getUrl;
        },
        newLog: (state) => {
            return state.newLog;
        },
        loggedUser: (state) => {
            return state.loggedUser;
        },
        warehouse: (state) => {
            return state.warehouse;
        },
        dossierLocation: (state) => {
            return state.dossierLocation;
        },
        version: (state) => {
            return state.version;
        },
        showHumanResourcesInErp: (state) => {
            return state.showHumanResourcesInErp;
        },
        showAliAloInProcess: (state) => {
            return state.showAliAloInProcess;
        },
        showLodComInProcess: (state) => {
            return state.showLodComInProcess;
        },
        copyright: (state) => {
            return state.copyright
        }
    },
    modules: {
        app: mApp,
        orcamento: mOrc,
        gps: mGps,
        tabs: mTabs,
        mixins: mMixins,
        alerts: mAlerts,
    }
})

export default store



// WEBPACK FOOTER //
// ./resources/js/store/index.js